export default {"src":"/_next/static/media/visa.32785750.svg","height":27,"width":53,"blurWidth":0,"blurHeight":0};